import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WalletsPage.KycPage.wizard.PersonsBasicStep.OwnershipExplanationPopup', {
    title: 'Who to add as owners',
    inTheExample:
        'In the below example, we would need to know about Person A and Person C, since they both own more than 10% of Company A either directly or indirectly.',
    weWouldNotNeed: 'We would not need to know about:',
    lineOne: 'Companies B, C and D, since there are corporates rather than people.',
    lineTwo: 'Person B, since they own less than 10% of Company A.',
    lineThree:
        'Any persons owning Company D as even if Company D was wholly owned by one person, the maximum amount they could own of Company A would be 7.5% which is below 10%.',
});
